handleCreateResponse